<template>
    <div>
    <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>日志管理</el-breadcrumb-item>
    </el-breadcrumb>
        <!-- 操作-->

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left" >
            <el-form :inline="true">

                <el-form-item label="菜单名称">
                    <el-input v-model="ruleForm.menuName" placeholder="设备管理" ></el-input>
                </el-form-item>
                <el-form-item label="操作名称">
                    <el-input v-model="ruleForm.operateName" placeholder="查询" ></el-input>
                </el-form-item>

            <el-form-item label="时间">
                        <el-date-picker
                                v-model="ruleForm.startTime"
                                type="date"
                                format="yyyy-MM-dd"
                                placeholder="">
                        </el-date-picker>
            </el-form-item>

                <el-form-item label="至">
                    <el-date-picker
                            v-model="ruleForm.endTime"

                            type="date"
                            format="yyyy-MM-dd"
                            placeholder=""
                            clearable
                    >

                    </el-date-picker>
                </el-form-item>



                <el-form-item>
                    <el-button type="primary"  @click="getData" icon="search":loading="loading" >查询</el-button>
                </el-form-item>


                <el-form-item>
                    <el-button type="primary" @click="resetForm()" >重置</el-button>
                </el-form-item>

            </el-form>
        </el-col>


        <!-- 表格分页-->
        <div class="block">
            <el-table :data="tableData" border style="width: 100%;" >
                <!--<el-table-column prop="tenant_name" label="租户">  </el-table-column>-->
                <el-table-column prop="user_name" label="用户">  </el-table-column>
                <el-table-column prop="ip" label="机器IP">  </el-table-column>
                <!--<el-table-column prop="category"  label="类型">-->
                    <!--&lt;!&ndash;&lt;!&ndash;<template scope="scope" >&ndash;&gt;&ndash;&gt;-->
                        <!--&lt;!&ndash;&lt;!&ndash;prop="category"&ndash;&gt;&ndash;&gt;-->
                        <!--&lt;!&ndash;&lt;!&ndash;<label v-if="scope"></label>&ndash;&gt;&ndash;&gt;-->
                    <!--&lt;!&ndash;&lt;!&ndash;</template>&ndash;&gt;&ndash;&gt;-->
                <!--</el-table-column>-->
                <el-table-column prop="menu_name" label="菜单名称">  </el-table-column>
                <!--<el-table-column prop="operate_desc" label="操作" > </el-table-column>-->
                <el-table-column prop="operate_name" label="操作名称" > </el-table-column>
                <el-table-column prop="update_time" label="更新时间"    sortable >  </el-table-column>
                <!--<el-table-column label="操作" width="350">-->
                    <!--<template scope="scope">-->
                        <!--<el-button  size="small" @click="userEdit(scope.row)"   v-if="btnAll.btn_0414 ">编辑</el-button> &lt;!&ndash;   v-bind:class="{ clearBtn: btnAll.btn_0414 }&ndash;&gt;-->
                        <!--<el-button  size="small" type="danger"  @click="handleDelete(scope.row)"  v-if="btnAll.btn_0415 "  >删除</el-button>-->
                        <!--<el-button  size="small" type="info" @click="addRoles(scope.row)" v-if="btnAll.btn_0416 " >绑定角色</el-button>-->
                        <!--<el-button  size="small" type="info" @click="configUserOrg(scope.row)" v-if="btnAll.btn_0417 " > 授权位置</el-button>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>
        </div>



        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import moment  from 'moment'
    export  default{
        data(){

            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                //参数设置
                url: this.requetHost+"/sys/log/findLogAll", // 分页查询请求路径
                name: '',
                loading:false,
                isable:false,
                dialogVisible: false,
                /*弹窗内容选择*/

                ruleForm:{
                    operateName:'',
                    startTime:'',
                    endTime:'',
                    //tenantId:'',
                    isAdmin:false,
                    menuName:'',
                },
                //tenantList:[],



            }

        },
        created(){


//            this.$store.dispatch('updateBtnState',"041")
//            this.updateBtnState("041");
//            this.btn_0412=true;
//            var tenantId=this.getcookie('tenant_id');
//
//
//            if(tenantId=='000000'){
//                this.ruleForm.isAdmin=true;
//
//                this.getTenantList();
//            }
//            this.ruleForm.tenantId=tenantId;
//            if(this.getcookie("tenant_id")!="000000"){
//                this.updateBtnState("041")
//            }
            this.getData();
        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求
                this.loading = true
                var formatstiem = "";

                if(this.ruleForm.endTime!=""){

                    this.ruleForm.endTime = moment(this.ruleForm.endTime).format("YYYY-MM-DD");
                   // this.ruleForm.endTime=new Date(this.ruleForm.endTime).format("yyyy-MM-dd HH:mm:ss")
                }
                if(this.ruleForm.startTime!=""){
                    this.ruleForm.startTime  = moment(this.ruleForm.startTime).format("YYYY-MM-DD");
                    //this.ruleForm.startTime=new Date(this.ruleForm.startTime).format("yyyy-MM-dd HH:mm:ss")
                }
                if(this.ruleForm.endTime!="" && this.ruleForm.startTime!=""){
                    var begin=new Date(this.ruleForm.startTime.replace(/-/g,"/"));
                    var end=new Date(this.ruleForm.endTime.replace(/-/g,"/"));
                    //js判断日期
                    if(begin-end>0){
                        this.$message({showClose: true, message: '结束日期不能早于开始日期', type: 'error'});
                        this.loading = false;
                        return false;
                    }else{
                        var params = {active:this.activeNum,
                            len:this.pagesize,
                            userId:this.getcookie('user_id'),
                            startTime:this.ruleForm.startTime,
                            endTime:this.ruleForm.endTime,
                            operateName:this.ruleForm.operateName,
                            menuName:this.ruleForm.menuName
                        };

                        //异步请求
                        this.$http.post(this.url,params)
                            .then(response => {
                                if (response.status === 200) {
                                    var newArr=[];
                                    this.pagesCount = response.body.total

                                    this.tableData = response.body.data.slice().sort();
                                    console.log("this.tableData "+this.tableData );
                                    this.loading = false;
                                    //this.getBtn();
                                }
                            },function(response){
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'

                                });
                            })
                    }
                }else{
                var params = {active:this.activeNum,
                    len:this.pagesize,
                    userId:this.getcookie('user_id'),
                    startTime:this.ruleForm.startTime,
                    endTime:this.ruleForm.endTime,
                    operateName:this.ruleForm.operateName,
                    menuName:this.ruleForm.menuName
                };

                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            this.pagesCount = response.body.total
                            this.tableData = response.body.data.slice(0);
                            console.log("this.tableData "+this );
                            this.loading = false;
                           //this.getBtn();
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
                }

            },
            formatter(row, column) {
                var d = new Date(row.update_time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },


//            getTenantList(){
//
//                    this.$store.dispatch("getTenantList").then((res) => {
//                        this.tenantList = res.tenants;
//                    }, () => {
//                        this.$message({showClose: true, message: '网络异常', type: 'error'});
//                    })
//
//
//            },
            resetForm(){
                this.ruleForm.operateName="";
                this.ruleForm.startTime="";
                this.ruleForm.endTime="";
                this.getData();
            }



        }



    }

</script>



// WEBPACK FOOTER //
// LogManager.vue?f41402f0